import { EnvManager } from '@services/environment/environment.service';
import envVariables from '@services/environment/variables';
import { logger } from '@services/logger/logger.service';
import Pusher, { Options } from 'pusher-js';

if (envVariables.NODE_ENV === 'development') {
  Pusher.log = (msg) => {
    logger.debug('LOGIC', `Pusher - ${msg}`);
  };
}

class RealtimeClient {
  private pusher: Pusher | null;

  public getClient(): Pusher {
    if (this.pusher) {
      return this.pusher;
    }

    // Init client
    // Get pusher key
    const key = EnvManager.getPusherAppKey();

    // Get pusher options
    const options: Options = {
      enableStats: false,
      cluster: 'eu',
      forceTLS: true,
      wsHost: EnvManager.getBaseUrlProxy(),
      wsPath: EnvManager.getPusherWsPath(),
    };
    this.pusher = new Pusher(key ?? '', options);
    return this.pusher;
  }

  public bindConnectionStateChange(
    callback: (data: { current: string; previous: string }) => void,
  ): () => void {
    const client = this.getClient();
    client.connection.bind('state_change', callback);
    return () => client.connection.unbind('state_change', callback);
  }
}

export const realtimeClient = new RealtimeClient();
